<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                '订单编号/客户订单编号/识别单号/下单客户/终端客户/名义工厂/执行工厂/业务人员 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="1000px"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-form ref="form" :model="form" size="small">
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item
              :label="$l('INDEX.order_form_label_orderNo') || '订单编号'"
            >
              <el-input
                v-model.trim="form.orderNo"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :label="
                $l('INDEX.order_form_label_custOrderNo') || '客户订单编号'
              "
            >
              <el-input
                v-model.trim="form.custOrderNo"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :label="$l('INDEX.order_form_label_identifyNo') || '识别单号'"
            >
              <el-input
                v-model.trim="form.identifyNo"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item
              :label="$l('INDEX.order_form_label_scmCode') || '执行工厂'"
            >
              <dict-select
                v-model="form.listScmCode"
                url="/master/common/dict/scmPartners"
                :placeholder="$l('INDEX.tips_select_data') || '请选择……'"
                clearable
                filterable
                multiple
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item
              :label="$l('INDEX.order_form_label_settlementFactory') || '结算工厂(乙方)'"
            >
              <dict-select
                v-model="form.listSettlementFactory"
                url="/master/common/dict/scmPartners"
                :placeholder="$l('INDEX.tips_select_data') || '请选择……'"
                clearable
                filterable
                multiple
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item :label="'名义工厂'">
              <dict-select
                v-model="form.listOrderScmCode"
                url="/master/common/dict/scmPartners"
                :placeholder="$l('INDEX.tips_select_data') || '请选择……'"
                clearable
                filterable
                multiple
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.order_form_label_custCode') || '下单客户'"
            >
              <dict-select
                v-model="form.listCustCode"
                url="/master/common/dict/customerSelect"
                :placeholder="$l('INDEX.tips_select_data') || '请选择……'"
                clearable
                filterable
                multiple
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.order_form_label_endCustCode') || '终端客户'"
            >
              <dict-select
                v-model="form.listEndCustCode"
                url="/master/common/dict/customerSelect"
                :placeholder="$l('INDEX.tips_select_data') || '请选择……'"
                clearable
                filterable
                multiple
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="'业务人员'">
              <dict-select
                v-model="form.listSalesPersonCode"
                url="/master/common/dict/baseUserSelect"
                :placeholder="$l('INDEX.tips_select_data') || '请选择……'"
                clearable
                filterable
                multiple
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="'跟单人员'">
              <dict-select
                v-model="form.listBizPersonCode"
                url="/master/common/dict/baseUserSelect"
                :placeholder="$l('INDEX.tips_select_data') || '请选择……'"
                clearable
                filterable
                multiple
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.order_form_label_orderType') || '订单类型'"
            >
              <dict-select
                v-model="form.listOrderType"
                url="/sys/common/dict/system"
                :body="orderTypeParams"
                :placeholder="$l('INDEX.tips_select_data') || '请选择……'"
                filterable
                clearable
                multiple
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.order_form_label_orderSource') || '订单来源'"
            >
              <dict-select
                v-model="form.listOrderSource"
                url="/master/common/dict/biz"
                :body="orderSourceTypeParams"
                :placeholder="$l('INDEX.tips_select_data') || '请选择……'"
                filterable
                clearable
                multiple
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item :label="'工厂付款条件'">
              <dict-select
                v-model="form.listFactoryPaymentTerms"
                url="/master/common/dict/biz"
                :body="factoryPaymentTermsParams"
                :placeholder="$l('INDEX.tips_select_data') || '请选择……'"
                filterable
                clearable
                multiple
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              label-width="100px"
              :label="$l('INDEX.order_form_label_reviewTime') || '审核时间'"
            >
              <el-row>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.reviewTimeStart"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="reviewTimeStartPicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.reviewTimeEnd"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="reviewTimeEndPicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label-width="100px"
              :label="$l('INDEX.form_label_modification_time') || '修改时间'"
            >
              <el-row>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyTimeStart"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="modifyTimeStartPicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyTimeEnd"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="modifyTimeEndPicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = { keyword: '' }
export default {
  data() {
    return {
      orderTypeParams: { dictType: 'orderType' },
      orderSourceTypeParams: { dictType: 'orderSource' },
      factoryPaymentTermsParams: { dictType: 'paymentTerms' },
      advqueryDialogVisible: false,
      form: { ...initForm },

      reviewTimeStartPicker: this.reviewTimeEnd(),
      reviewTimeEndPicker: this.reviewTimeStart(),
      modifyTimeStartPicker: this.modifyTimeEnd(),
      modifyTimeEndPicker: this.modifyTimeStart(),
    }
  },
  created() {
    this.query()
  },
  methods: {
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    modifyTimeEnd() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.modifyTimeEnd) {
            return new Date(self.form.modifyTimeEnd).getTime() < time.getTime()
          }
        },
      }
    },
    modifyTimeStart() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.modifyTimeStart) {
            return (
              new Date(self.form.modifyTimeStart).getTime() - 3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
    reviewTimeEnd() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.reviewTimeEnd) {
            return new Date(self.form.reviewTimeEnd).getTime() < time.getTime()
          }
        },
      }
    },
    reviewTimeStart() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.reviewTimeStart) {
            return (
              new Date(self.form.reviewTimeStart).getTime() - 3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
